import { filter } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Flex } from "rebass";
import { getLocalizedString } from "../../utils";
import { NumericPad } from "./NumericPad";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import config from "../../utils/globalConfig";
import TicketMobile from "../../icons/TicketMobile";
import AddShopppingMobile from "../../icons/AddShopppingMobile";
import SlidersBackMobile from "../../icons/SlidersBackMobile";
import { ColorTooltip } from "../common/ColorTooltip";
import { Price } from "../common/Price";
import { ChangeColorIcon } from "../../icons/ChangeColorIcon";
import { GoBackIcon } from "../../icons/GoBack";
import sizeSort from "../../utils/sizeSort";
const availabilityColorsMap = {
  green: "#249d4e",
  yellow: "#cea418",
  red: "#f04836",
};

const AvailabilityMobile = ({
  element,
  totalQnt,
  totalPrice,
  onCancel,
  price,
  id,
  fixedPrice,
  onClose,
  type,
  changeColor,
}) => {
  const { catalogueItemDetails, catalogueItemDetailsSwap } = useSelector(
    (state) => state.yodaCatalogue,
  );
  const { order, orderRowDetails } = useSelector((state) => state.yodaOrders);
  const { customer } = useSelector((state) => state.yodaCustomer);
  const { me } = useSelector((state) => state.yodaStakeholders);
  const { orderId } = useParams();
  const navigate = useHistory();
  const [selectedDoor, setSelectedDoor] = useState(null);
  const [priceState, setPriceState] = useState();
  const [quantity, setQuantity] = useState();
  const [editingMobile, setEditingMobile] = useState(null);
  const { hidePrice } = useSelector((state) => state.system);

  useEffect(() => {
    if (selectedDoor === null) {
      const firstDoorId = order?.customData?.doors?.[0];
      const firstDoor = customer.doors.find((door) => door.id === firstDoorId);
      setSelectedDoor(firstDoor || null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer?.doors, order?.customData?.doors]);

  useEffect(() => {
    const catalogueitem =
      type === config.ORDER_TYPE_REORDER
        ? catalogueItemDetails[id]
        : catalogueItemDetailsSwap[id];
    const catalogueId = catalogueitem?.catalog?.find(
      (f) => f.colorCode == element.code,
    )?.catalogId;

    let tmpArr = filter(
      orderRowDetails,
      (k, v) =>
        k.catalogId == catalogueId &&
        selectedDoor?.id == k.customData.doorId &&
        k.customData.typeId == type,
    );

    let quantity = 0;
    let price = 0;

    tmpArr.forEach((e) => {
      quantity += e.currentQuantity;
      price += e.price;
    });

    setQuantity(quantity);
    setPriceState(price);
  }, [
    selectedDoor,
    catalogueItemDetails,
    catalogueItemDetailsSwap,
    element.code,
    id,
    order?.customData?.doors,
    orderRowDetails,
    type,
  ]);

  return (
    <Flex
      height="calc(100dvh - 50px)"
      width="100vw"
      m="0"
      p="0"
      style={{
        position: "fixed",
        top: "50px",
        left: 0,
        zIndex: 3,
        overflowX: "hidden",
        overflowY: "hidden",
      }}
      bg="#f3f3f3"
    >
      {/* LEFT BAR */}
      <Flex width="33.3vw" flexDirection="column" style={{ zIndex: 4 }}>
        <Flex
          px="10px"
          pt="5px"
          justifyContent="center"
          flexDirection="column"
          bg="#dedede"
          pb="5px"
        >
          <span
            style={{
              fontWeight: "bold",
              textAlign: "center",
              wordWrap: "break-word",
            }}
          >
            {element.colorDescription}
          </span>
          <ColorTooltip
            id={id}
            code={element.code}
            colorDescription={element.colorDescription}
            rgb={element.rgb}
            componentName={"catalogueGrillReorderSwapAndPopup"}
          />
          <Flex flexDirection="column" px="10px">
            <span>{getLocalizedString("Prezzo")}</span>
            <span style={{ fontWeight: "bold" }}>
              <Price price={fixedPrice || price} />
            </span>
          </Flex>
        </Flex>
        {/* DOORS */}
        <Flex
          flexDirection="column"
          style={{ gap: "2px", borderBottom: "2px solid white" }}
          justifyContent="center"
          mt="2px"
        >
          {order?.customData?.doors?.map((doorId, i) => {
            const doorData = customer?.doors?.find?.(
              (door) => door.id === doorId,
            );
            const isSelected = selectedDoor?.id === doorId;
            return (
              <Flex
                height="50px"
                width="100%"
                bg={isSelected ? "#303130" : "#dedede"}
                key={`doors-${i}-${doorId}`}
                alignItems="center"
                justifyContent="center"
                onClick={() => setSelectedDoor(doorData)}
              >
                <span style={{ color: isSelected && "white" }}>
                  {getLocalizedString("Porta")}&nbsp;
                </span>
                <span
                  style={{
                    fontWeight: "bold",
                    color: isSelected && "white",
                  }}
                >
                  {doorData?.code}
                </span>
              </Flex>
            );
          })}
        </Flex>
        {/* END - DOORS */}
        <Flex style={{ borderLeft: "10px solid #dedede" }} height="100%"></Flex>
        {/* BUTTONS */}
        <Flex
          flexDirection="column"
          style={{ position: "absolute", bottom: "0px" }}
          width="calc(100% - 66.6vw)"
          bg="white"
        >
          <Flex
            height="55px"
            width="100%"
            mt="2px"
            bg="#f3f3f3"
            onClick={onCancel}
          >
            <Box bg="#dedede" width="10px" />
            <Flex height="100%" alignItems={"center"} ml="auto" mr="auto">
              <ChangeColorIcon onClick={changeColor} />
            </Flex>
          </Flex>
          <Flex
            height="55px"
            width="100%"
            mt="2px"
            bg="#f3f3f3"
            onClick={onCancel}
          >
            <Box bg="#dedede" width="10px" />
            {/* <Box pt="10px" ml="25px">
                            <HiOutlineChevronDoubleLeft color="#303130" size="25px"/>
                        </Box> */}
            <Flex height="100%" alignItems={"center"} ml="auto" mr="auto">
              {/* <HiShoppingCart color="#303130" size="25px"/> */}
              <AddShopppingMobile />
            </Flex>
          </Flex>
          <Flex
            height="55px"
            width="100%"
            mt="2px"
            bg="#f3f3f3"
            onClick={() => navigate.push(`/orderDetail/${orderId}`)}
          >
            <Box bg="#dedede" width="10px" />
            <Flex height="100%" alignItems={"center"} ml="auto" mr="auto">
              <TicketMobile />
            </Flex>
          </Flex>
          <Flex
            onClick={() => onClose()}
            height="55px"
            width="100%"
            mt="2px"
            bg="#f3f3f3"
          >
            <Box bg="#dedede" width="10px" />
            {/* <Box pt="10px" ml="25px">
                            <HiOutlineChevronDoubleRight color="#303130" size="25px"/>
                        </Box> */}
            <Flex height="100%" alignItems={"center"} ml="auto" mr="auto">
              {/* <BsColumnsGap color="#303130" size="25px"/> */}
              <SlidersBackMobile />
            </Flex>
          </Flex>
        </Flex>
        {/* END - BUTTONS */}
      </Flex>
      {/* END - LEFT BAR */}
      {/* SIZE SELECTORS */}
      <Flex
        width="66.6vw"
        flexDirection="column"
        bg="#303130"
        sx={{ position: "relative" }}
      >
        <Flex width="100%" flex={1} overflowY={"hidden"}>
          <Flex
            width="100%"
            height="100%"
            flexDirection="column"
            overflowY={"auto"}
          >
            <Box
              px="20px"
              width="100%"
              sx={{
                display: "grid",
                gridTemplateColumns: "25%  75%",
                gap: "10px",
                color: "white",
                fontSize: "9px",
                marginTop: "10px",
              }}
            >
              <Box></Box>
              <Flex alignItems={"flex-end"}>
                <Box width={"30%"} textAlign={"center"}>
                  DISP.
                </Box>
                <Box
                  width={"26%"}
                  textAlign={"center"}
                  sx={{ fontSize: "14px", fontWeight: "bold" }}
                >
                  {getLocalizedString("QTA")}
                </Box>
              </Flex>
            </Box>
            {element?.values?.sort(sizeSort).map((val, i) => {
              const isEdited = editingMobile === val.sizeCode;
              return (
                <Box
                  px="20px"
                  width="100%"
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "25%  75%",
                    gap: "10px",
                    ...(editingMobile !== null &&
                      !isEdited && {
                        opacity: 0.5,
                        pointerEvents: "none",
                      }),
                  }}
                  mb="10px"
                  key={`size-${i}-${val.size}`}
                >
                  <Box
                    sx={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "white",
                      position: "relative",
                      top: "3px",
                    }}
                  >
                    {val.size}
                  </Box>
                  <Flex mt="7px" maxHeight="25px">
                    <Flex
                      bg={
                        val.quantity > 0
                          ? availabilityColorsMap["green"]
                          : availabilityColorsMap["red"]
                      }
                      width="30%"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <span style={{ color: "white" }}>
                        {me?.role.includes?.("CustomerCare") ||
                        me?.role.includes?.("Agents") ||
                        me?.role.includes?.("Customer")
                          ? val.quantity
                          : ""}
                      </span>
                    </Flex>
                    <Flex
                      width="60%"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <NumericPad
                        index={i}
                        id={id}
                        type={type}
                        sizeCode={val.sizeCode}
                        door={selectedDoor?.id}
                        color={element.code}
                        quantity={
                          element.values.filter(
                            (f) => f.sizeCode == val.sizeCode,
                          )[0].quantity
                        }
                        {...{ editingMobile, setEditingMobile }}
                      ></NumericPad>
                    </Flex>
                  </Flex>
                </Box>
              );
            })}
          </Flex>
        </Flex>
        <Flex flexDirection="column">
          <Flex
            px="30px"
            pt={"4px"}
            style={{
              gap: "25px",
              borderBottom: "1px solid white",
            }}
            width="66.6vw"
            pb="10px"
            justifyContent="space-between"
            bg="#232323"
          >
            <Flex flexDirection="column" width="30px">
              <span style={{ color: "white", fontSize: "9px" }}>
                {getLocalizedString("Porta")}
              </span>
              <Flex style={{ borderRight: "1px solid white" }}>
                <span
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  {selectedDoor?.code || ""}
                </span>
              </Flex>
            </Flex>
            <Flex flexDirection="column" width="30px">
              <span style={{ color: "white", fontSize: "9px" }}>
                {getLocalizedString("QTA")}
              </span>
              <Flex style={{ borderRight: "1px solid white" }}>
                <span
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  {quantity}
                </span>
              </Flex>
            </Flex>
            <Flex flexDirection="column">
              <span style={{ color: "white", fontSize: "9px" }}>Val</span>
              <span
                style={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "20px",
                  whiteSpace: "nowrap",
                }}
              >
                <Price price={priceState} />
              </span>
            </Flex>
          </Flex>
          <Flex
            bg="#232323"
            width="66.6vw"
            height="55px"
            alignItems="center"
            justifyContent="space-between"
            px="40px"
          >
            <Flex ml="-26px">
              <span
                style={{
                  color: "white",
                  fontSize: "20px",
                }}
              >
                {getLocalizedString("TOTALE")}&nbsp;
              </span>
              <span style={{ color: "white", fontSize: "20px" }}>
                {totalQnt}
              </span>
            </Flex>
            <Flex
              width="1px"
              mx="5px"
              height="50%"
              style={{ borderLeft: "1px solid white" }}
            />
            <Flex>
              <span
                style={{
                  color: "white",
                  fontSize: "20px",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                <Price price={totalPrice} />
              </span>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      {/* END - SIZE SELECTORS */}
    </Flex>
  );
};

export default AvailabilityMobile;
